import {
  ICreateFileSubmissionRequest,
  ICreateJobFileRequest,
  ICreatePaymentSubmissionRequest,
  IFileSubmission,
  IGeneratedFiles,
  IGeneratedFilesPending,
  IGetJobStatusRequest,
  IGetTXPDataFromDeadlinesRequest,
  IPaymentSubmission,
  IResponseBase,
  ITXPMetaResponse,
} from "@zeal/common";
import {
  IGetReportingPeriodByIdRequest,
  IGetReportingPeriodByIdResponse,
} from "./routes/get_reporting_period_by_id";
import {
  IAmountPaidSummary,
  IGetOutstandingPayments,
} from "@zeal/common/dist/bolarus/IGetOutstandingPayments";
import {
  IGetCollectorDefinitionsRequest,
  IGetCollectorDefinitionsResponse,
} from "@zeal/common/dist/bolarus/collectors";
import { IUpdateDeadline } from "@zeal/common/dist/bolarus/deadline_types";
import {
  IGetOustandingDeadlinesSummaryRequest,
  IGetOustandingDeadlinesSummaryResponse,
  IGetPaymentDeadlinesForCompanyIDRequest,
} from "@zeal/common/dist/bolarus/payment_deadlines";
import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../AbstractApiClient/IApiResponse";
import { createFileJob } from "./routes/create_file_job";
import { createFileSubmission } from "./routes/create_file_submission";
import { getCollectors } from "./routes/get_collectors";
import { getDeadlines } from "./routes/get_deadlines";
import { getReportingPeriodById } from "./routes/get_reporting_period_by_id";
import { checkJobStatus } from "./routes/get_job_status";
import { getSummary } from "./routes/get_summary";
import { getTXPMeta } from "./routes/get_txp_from_deadlines";
import { postPaymentSubmission } from "./routes/post_payment_submission";
import { updateDeadline } from "./routes/update_deadlines";
import { updatePaymentSubmission } from "./routes/update_payment_submission";

export interface IBolarusClient {
  getCollectorDefinitions(
    body: IGetCollectorDefinitionsRequest
  ): Promise<IResponseBase<IGetCollectorDefinitionsResponse[]>>;
  getDeadlineSummary(
    body: IGetOustandingDeadlinesSummaryRequest
  ): Promise<IResponseBase<IGetOustandingDeadlinesSummaryResponse[]>>;
  getDeadlines(
    body: IGetPaymentDeadlinesForCompanyIDRequest
  ): Promise<IResponseBase<IGetOutstandingPayments[]>>;
  getTXPMeta(
    body: IGetTXPDataFromDeadlinesRequest
  ): Promise<IResponseBase<ITXPMetaResponse[]>>;
  postPaymentSubmission(
    body: ICreatePaymentSubmissionRequest[]
  ): Promise<IResponseBase<IPaymentSubmission[]>>;
  checkJobStatus(
    body: IGetJobStatusRequest
  ): Promise<IApiResponse<IGeneratedFiles>>;
  createFileJob(
    body: ICreateJobFileRequest
  ): Promise<IResponseBase<IGeneratedFilesPending>>;
  createFileSubmission(
    body: ICreateFileSubmissionRequest
  ): Promise<IResponseBase<IFileSubmission>>;
  updateDeadline(body: IUpdateDeadline): Promise<any>;
  updatePaymentSubmission(body: IAmountPaidSummary[]): Promise<any>;
  getReportingPeriodById(
    body: IGetReportingPeriodByIdRequest
  ): Promise<IResponseBase<IGetReportingPeriodByIdResponse>>;
}

export class BolarusClient extends AbstractApiClient implements IBolarusClient {
  public readonly getCollectorDefinitions = getCollectors(this.Instance);
  public readonly getDeadlineSummary = getSummary(this.Instance);
  public readonly getDeadlines = getDeadlines(this.Instance);
  public readonly getTXPMeta = getTXPMeta(this.Instance);
  public readonly postPaymentSubmission = postPaymentSubmission(this.Instance);
  public readonly checkJobStatus = checkJobStatus(this.Instance);
  public readonly createFileJob = createFileJob(this.Instance);
  public readonly createFileSubmission = createFileSubmission(this.Instance);
  public readonly updateDeadline = updateDeadline(this.Instance);
  public readonly updatePaymentSubmission = updatePaymentSubmission(
    this.Instance
  );
  public readonly getReportingPeriodById = getReportingPeriodById(
    this.Instance
  );
}
